import withEnterAccountPassword from '../../hoc/with-enter-account-password'
import Settings from '../../components/settings'

export default withEnterAccountPassword(Settings)
